// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"358495bd","446":"dcf57de0"}[chunkId] + ".chunk.css";
};